var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isLoading)?_c('div',{attrs:{"id":"loading-wrap"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fa-3x"},[_c('i',{staticClass:"fa fa-spinner fa-pulse"})])
}]

export { render, staticRenderFns }